// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  margin-top: 2%;
}
.card * {
  font-size: 14px;
}

.fs-12, .uploadedDate {
  font-size: 12px;
}

.text-right {
  text-align: right !important;
}

.cert-name {
  font-weight: bold;
}

.action-icons {
  height: 16px;
  width: 16px;
  margin-right: 2%;
  cursor: pointer;
}

.copy-button {
  cursor: pointer;
}
.copy-button:hover {
  color: cornflowerblue;
}

.overlay {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background: #222;
}

.overlay__inner {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.overlay__content {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.spinner {
  width: 75px;
  height: 75px;
  display: inline-block;
  border-width: 2px;
  border-color: rgba(255, 255, 255, 0.05);
  border-top-color: #fff;
  animation: spin 1s infinite linear;
  border-radius: 100%;
  border-style: solid;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.uploaded-by {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/upload-pfx/index.scss"],"names":[],"mappings":"AAAA;EACI,iDAAA;EACA,cAAA;AACJ;AAAI;EACI,eAAA;AAER;;AAEA;EACI,eAAA;AACJ;;AAMA;EACI,4BAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;AAII;EACI,qBAAA;AAFR;;AAMA;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,SAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,uCAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;;AAMA;EACE;IACE,yBAAA;EAHF;AACF;AAMA;EACI,eAAA;AAJJ","sourcesContent":[".card {\n    box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);\n    margin-top: 2%;\n    * {\n        font-size: 14px;\n    }\n}\n\n.fs-12 {\n    font-size: 12px;\n}\n\n.uploadedDate {\n    @extend .fs-12;\n}\n\n.text-right {\n    text-align: right !important;\n}\n\n.cert-name {\n    font-weight: bold;\n}\n\n.action-icons {\n    height: 16px;\n    width: 16px;\n    margin-right: 2%;\n    cursor: pointer;\n}\n\n.copy-button {\n    cursor: pointer;\n    &:hover {\n        color: cornflowerblue;\n    }\n}\n\n.overlay {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    background: #222;\n}\n\n.overlay__inner {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n}\n\n.overlay__content {\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.spinner {\n    width: 75px;\n    height: 75px;\n    display: inline-block;\n    border-width: 2px;\n    border-color: rgba(255, 255, 255, 0.05);\n    border-top-color: #fff;\n    animation: spin 1s infinite linear;\n    border-radius: 100%;\n    border-style: solid;\n}\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.uploaded-by {\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
